var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorLayout',[_c('p',[_vm._v("パスワードの有効期限が切れています。")]),_c('p',[_vm._v("新しいダミーIDとパスワードを発行して、再度ログインしてください。")])])}
var staticRenderFns = []

export { render, staticRenderFns }